import React from 'react';
import PropTypes from 'prop-types';
// components
import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
// formatters
import { FormattedDate } from 'react-intl';
import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
// icons
import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';

// business logic
const sortMethods = {
    default: function(a, b) { return a.id - b.id; },
    fullName: function(a, b) { return a.fullName.localeCompare(b.fullName); },
    moduleName: function(a, b) { return (a.moduleName.localeCompare(b.moduleName)); }
};

const ReportEnrolmentProgress = React.createClass({

    getInitialState: function () {
        return {
            sortName: 'default',
            sort: sortMethods.default,
            statuses: ['waiting', 'enrolled', 'completed'],
            filters: {
                name: '',
                organisation: '',
                moduleName: '',
                enrolledFrom: null,
                enrolledFromTime: null,
                enrolledTo: null,
                enrolledToTime: null,
                status: '',
                scoreMin: '',
                scoreMax: '',
                completedFrom: null,
                completedFromTime: null,
                completedTo: null,
                completedToTime: null,
            }
        };
    },

    style: {
        textFilter: {
            width: '100%'
        },
        dateFilter: {
            width: '100%'
        },
        dropdownFilter: {
            width: '100%'
        }
    },
    
    render: function() {
        const data = this.props.data
            .filter(this.filterData)
            .sort(this.state.sort);
        
        // TODO: filters from url clickthrough?
        const tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        const tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        const tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };

        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }
        const textFilterProps = {
            hintText: 'Filter',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };

        const dropdownFilterProps = {
            hintText: 'Filter',
            onChange: this.setDropdownFilter,
            style:    this.style.dropdownFilter
        };

        const minFilterProps = {
            hintText: 'Minimum',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };
        if (this.state.filters.scoreMin !== '' && isNaN(Number(this.state.filters.scoreMin))) {
            minFilterProps.errorText = 'Please enter a number';
        }
        const maxFilterProps = {
            hintText: 'Maximum',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };
        if (this.state.filters.scoreMax !== '' && isNaN(Number(this.state.filters.scoreMax))) {
            maxFilterProps.errorText = 'Please enter a number';
        }
        const dateFilterProps = {
            formatDate:     this._formatDate,
            style:          this.style.dateFilter,
            textFieldStyle: this.style.dateFilter,
            required: false
        };

        const { filters } = this.state;

        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>
                            Name
                            <IconButton onMouseUp={this._setSort('fullName')} onTouch={this._setSort('fullName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Organisation</TableHeaderColumn>
                        <TableHeaderColumn>Module Name
                            <IconButton onMouseUp={this._setSort('moduleName')} onTouch={this._setSort('moduleName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Enrolment</TableHeaderColumn>
                        <TableHeaderColumn>Status</TableHeaderColumn>
                        {this.props.showScore && <TableHeaderColumn>Score</TableHeaderColumn>}
                        <TableHeaderColumn>Completion</TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                        <TableHeaderColumn>
                            <TextField name="name" value={filters.name} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="organisation" value={filters.organisation} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="moduleName" value={filters.moduleName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={this.setEnrolledFromFilter} {...dateFilterProps} maxDate={filters.enrolledTo} />
                            <DatePicker hintText="To"   onChange={this.setEnrolledToFilter}   {...dateFilterProps} minDate={filters.enrolledFrom} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <SelectField name="status" value={filters.status} {...dropdownFilterProps} onChange={this.setStatusFilter} >
                                <MenuItem value="" primaryText="No filter" label=" " />
                                {this.state.statuses.map(function(status, index) {
                                    return <MenuItem key={index} value={status} primaryText={status} />;
                                })}
                            </SelectField>
                        </TableHeaderColumn>
                        {this.props.showScore && (
                            <TableHeaderColumn>
                                <TextField name="scoreMin" value={filters.scoreMin} {...minFilterProps} /><br />
                                <TextField name="scoreMax" value={filters.scoreMax} {...maxFilterProps} />
                            </TableHeaderColumn>
                        )}
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={this.setCompletedFromFilter} {...dateFilterProps} maxDate={filters.completedTo} />
                            <DatePicker hintText="To"   onChange={this.setCompletedToFilter}   {...dateFilterProps} minDate={filters.completedFrom} />
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map(function (row, index) {
                        const moduleName = `${row.moduleName} (${row.moduleCode})`;
                        const dateEnrolled = (!!row.dateEnrolled
                            ?  <FormattedDate {...DateStyles.long} value={row.dateEnrolled} />
                            : ''
                        );

                        const dateCompleted = (!!row.dateCompleted
                            ? <FormattedDate {...DateStyles.long} value={row.dateCompleted} />
                            : ''
                        );

                        const organisations = this.getList(row.organisations);
                        const orgTitle = row.organisations.replace(/\|/g, "\n");

                        return (
                            <TableRow key={index} selected={row.selected} style={{color: !row.archived ? statusColours.default : statusColours.waiting}}>
                                <TableRowColumn>
                                    {!row.archived
                                        ? row.fullName
                                        : <span title="Archived user">{row.fullName}</span>
                                    }
                                </TableRowColumn>
                                <TableRowColumn title={orgTitle} >{organisations}</TableRowColumn>
                                <TableRowColumn>{moduleName}</TableRowColumn>
                                <TableRowColumn>{dateEnrolled}</TableRowColumn>
                                <TableRowColumn>{row.status}</TableRowColumn>
                                {this.props.showScore && <TableRowColumn>{row.score}</TableRowColumn>}
                                <TableRowColumn>{dateCompleted}</TableRowColumn>
                            </TableRow>
                        );
                    }, this)}
                </TableBody>

            </Table>
        );
    },

    _setSort: function(sort) {
        return () => {
            if (sortMethods.hasOwnProperty(sort) && this.state.sortName !== sort) {
                this.setState({sortName: sort, sort: sortMethods[sort]});
            }
        };
    },

    setTextFilter: function(event) {
        this._setFilter(event.target.name, event.target.value.toLocaleLowerCase());
    },

    setStatusFilter: function(event, i, value) {
        this._setFilter('status', value);
    },

    setEnrolledFromFilter: function(event, value) {
        this._setFilter('enrolledFrom', value);
    },
    
    setEnrolledToFilter: function(event, value) {
        this._setFilter('enrolledTo', value);
    },

    setCompletedFromFilter: function(event, value) {
        this._setFilter('completedFrom', value);
    },
    
    setCompletedToFilter: function(event, value) {
        this._setFilter('completedTo', value);
    },
    
    _setFilter: function(filter, value) {
        if (this.state.filters.hasOwnProperty(filter)) {
            let filters = this.state.filters;
            filters[filter] = value ;
            if (filters.hasOwnProperty(filter + 'Time')) {
                filters[filter + 'Time'] = (value instanceof Date ? value.getTime() : '');
            }
            this.setState({filters: filters});
        }
    },

    filterData: function(row) {
        let valid = (row !== undefined);
        if (valid && !!this.state.filters.name) {
            valid = (-1 < row.fullName.toLocaleLowerCase().search(this.state.filters.name));
        }
        
        if (valid && !!this.state.filters.organisation) {
            valid = (-1 < row.organisations.toLocaleLowerCase().search(this.state.filters.organisation));
        }
        
        if (valid && !!this.state.filters.moduleName) {
            valid = (-1 < row.moduleName.toLocaleLowerCase().search(this.state.filters.moduleName));
        }

        if (valid && !!this.state.filters.status) {
            valid = row.status === this.state.filters.status;
        }

        if (valid && this.state.filters.scoreMin !== '' && !isNaN(Number(this.state.filters.scoreMin))) {
            valid = (this.state.filters.scoreMin <= row.score);
        }

        if (valid && this.state.filters.scoreMax !== '' && !isNaN(Number(this.state.filters.scoreMax))) {
            valid = (row.score <= this.state.filters.scoreMax);
        }

        let enrolled = (new Date(row.dateEnrolled)).setHours(0, 0, 0);
        
        if (valid && !!this.state.filters.enrolledFrom) {
            valid = (this.state.filters.enrolledFromTime <= enrolled);
        }
        if (valid && !!this.state.filters.enrolledTo) {
            valid = ( enrolled <= this.state.filters.enrolledToTime );
        }

        let completed = false;
        if (row.dateCompleted !== null) {
            completed = (new Date(row.dateCompleted)).setHours(0, 0, 0);
        }

        if (valid && !!this.state.filters.completedFrom) {
            valid = (!!completed && this.state.filters.completedFromTime <= completed);
        }
        
        if (valid && !!this.state.filters.completedTo) {
            valid = (!!completed && completed <= this.state.filters.completedToTime );
        }
        return valid;
    },

    _formatDate: function(date) {
        if(date instanceof Date) {
            return new Intl.DateTimeFormat().format(date);
        }
    },
        
    getList: function (line, separator) {
        let list = '';
        const spanProps = {
            style: {
                marginRight: '1em'
            },
            className: 'inline-list'
        };
        if (!!line) {
            list = line.split(separator || '|')
                .map(function (e, i) {
                    return <span key={i} {...spanProps} >{e}</span>;
                });
        }
        return list;
    }

});

ReportEnrolmentProgress.propTypes = {
    display:        PropTypes.object,
    onRowSelect:    PropTypes.func,
    data:           PropTypes.arrayOf(PropTypes.object),
    showScore:      PropTypes.bool,
};

ReportEnrolmentProgress.defaultProps = {
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        showCheckboxes: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
    },
    data: [],
    showScore: true
};

export default ReportEnrolmentProgress;
